const BugReport = ({ width = 24, height = 24, fill = "currentColor" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 4C8 4 5 7 5 11V15C5 18.866 7.686 22 12 22C16.314 22 19 18.866 19 15V11C19 7 16 4 12 4Z"
      stroke={fill}
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M12 22V13"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 4C11.45 4 11 3.55 11 3C11 2.45 11.45 2 12 2C12.55 2 13 2.45 13 3C13 3.55 12.55 4 12 4Z"
      stroke={fill}
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M15.5 8L16.54 6.96C16.77 6.73 17.15 6.73 17.37 6.96C17.59 7.19 17.59 7.56 17.37 7.79L16.5 8.67"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.5 8L7.46 6.96C7.23 6.73 6.85 6.73 6.63 6.96C6.41 7.19 6.41 7.56 6.63 7.79L7.5 8.67"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="9" cy="13" r="1" fill={fill} />
    <circle cx="15" cy="13" r="1" fill={fill} />
    <circle cx="12" cy="16" r="1" fill={fill} />
  </svg>
);

export default BugReport;
